import React from 'react';
import { Assistant } from '@/types';
import { AssistantGrid } from './';
import GPTformeFavicon from '@/assets/GPTforme Favicon.svg';

interface AssistantSelectionPageProps {
    assistants: Record<string, Assistant>;
    onAssistantSelect: (assistantId: string) => void;
}

export const AssistantSelectionPage: React.FC<AssistantSelectionPageProps> = ({
                                                                                  assistants,
                                                                                  onAssistantSelect
                                                                              }) => {
    return (
        <div className="flex flex-col items-center justify-center min-h-[50vh] px-4">
            <img
                src={GPTformeFavicon}
                alt="GPTforme"
                className="w-16 h-16 sm:w-24 sm:h-24 md:w-32 md:h-32 mb-4 sm:mb-6"
            />
            <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-2 sm:mb-3 text-center">
                Choose Your AI Assistant
            </h2>
            <p className="text-gray-300 text-center max-w-md mb-6 sm:mb-8 text-xs sm:text-sm md:text-base">
                Select an assistant below to start chatting
            </p>

            <AssistantGrid
                assistants={assistants}
                onAssistantSelect={onAssistantSelect}
            />
        </div>
    );
};